// src/config/registreRoles.ts — SCE Issues
// Les rôles lus dans SharePoint (panneau d'administration, 22/10), tenus en
// mémoire pour les fonctions de config, qui restent SYNCHRONES : isCoordinateur,
// getBE, accesFnct, comptePartage… lisent ici, sinon leurs valeurs du code.
//
// Rempli deux fois au démarrage : par la copie locale (main.tsx, avant le
// premier rendu) puis par SharePoint (features/roles). Un changement réel
// (JSON différent) prévient les abonnés : App.tsx remonte alors l'appli, pour
// que droits, accueil et menus reprennent la nouvelle liste.
//
// N'importe aucun fichier de config : ce sont eux qui l'importent.

import type { Roles } from '@/utils/roles'

let charges: Roles | null = null
let empreinte = ''
let version = 0
const abonnes = new Set<() => void>()

/** Les rôles lus dans SharePoint (ou leur copie locale) ; null : valeurs du code. */
export function rolesCharges(): Roles | null {
  return charges
}

/**
 * Remplace les rôles ; ne prévient les abonnés que si quelque chose a changé.
 * `prevenir: false` : le panneau d'administration, qui vient d'écrire, garde
 * sa page telle quelle (pas de remontage à chaque ajout) ; le reste de l'appli
 * prend la liste au prochain rendu ou à la prochaine ouverture.
 */
export function definirRolesCharges(r: Roles | null, { prevenir = true }: { prevenir?: boolean } = {}): void {
  const e = r ? JSON.stringify(r) : ''
  if (e === empreinte) return
  charges = r
  empreinte = e
  if (!prevenir) return
  version += 1
  for (const f of abonnes) f()
}

/** S'abonner aux changements (useSyncExternalStore). */
export function abonnerRoles(f: () => void): () => void {
  abonnes.add(f)
  return () => {
    abonnes.delete(f)
  }
}

/** Numéro de version : change à chaque nouvelle liste. */
export function versionRoles(): number {
  return version
}
